import HttpService from '@/services/http/http.service';
import { GuildBankTabsViewModel, GuildEventLogViewModel, GuildMemberStatusViewModel, GuildsViewModel, GuildViewModel } from '@/types/apiServerContract';

const API_PATH = 'guild/';

export class GuildsApi {
    public static async GetGuildById(realmId: number, guildId: number): Promise<GuildViewModel> {
        return HttpService.Get(API_PATH + 'GetGuildById', {
            realmId,
            guildId
        });
    }

    public static async GetGuildByName(realmId: number, name: string): Promise<GuildViewModel> {
        return HttpService.Get(API_PATH + 'GetGuildByName', {
            realmId,
            name
        });
    }

    public static async Search(realmId: number, term: string): Promise<GuildsViewModel> {
        return HttpService.Get(API_PATH + 'Search', {
            realmId,
            term
        });
    }

    public static async GetGuildEventLogs(realmId: number, guildId: number): Promise<GuildEventLogViewModel> {
        return HttpService.Get(API_PATH + 'GetGuildEventLogs', {
            realmId,
            guildId
        });
    }

    public static async GetGuildMemberStatus(realmId: number, guildId: number): Promise<GuildMemberStatusViewModel> {
        return HttpService.Get(API_PATH + 'GetGuildMemberStatus', {
            realmId,
            guildId
        });
    }

    public static async GetGuildBankTabs(realmId: number, guildId: number): Promise<GuildBankTabsViewModel> {
        return HttpService.Get(API_PATH + 'GetGuildBankTabs', {
            realmId,
            guildId
        });
    }
}
